module.exports = __webpack_public_path__ + "img/jwcy3.befff48f.png";